/**
 * launch-dependencies.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { FactoryProvider, Injectable, OpaqueToken } from "@angular/core";

import { AggregationService } from "./aggregation/aggregation.service";
import { AlertService } from "./common/alert.service";
import { DebugService } from "./debug/debug.service";
import { NavigationHistoryService } from "./debug/navigation-history.service";
import { CollaborationService } from "./intake-form/collaboration.service";
import { SearchService } from "./search/search.service";
import { MessagingService } from "./server/messaging.service";
import { SubjectService } from "./subjects/subject.service";
import { UseModalsForBrowserAlerts } from "./support/utilities/modals";
import { WatchlistService } from "./watchlist/watchlist.service";

/**
 * Load files with ambient side effects.
 */
import "./debug/console-interceptor";;

/**
 * Do nothing.
 * (This is an opportunity to log or inspect things, but in production it's
 * merely a noop function necessary to trigger load of its dependencies.)
 */
export function init () : null
{
  return null;
}

/**
 * An injection token used to actually request the provider.
 */
export const LAUNCH_DEPENDENCIES : OpaqueToken = new OpaqueToken("LD");

/**
 * This provider triggers load of services that need to be ready to receive
 * messages "immediately" (i.e. config messages that are part of the initial
 * post-auth message bundle) but would not be guaranteed to have been injected
 * by another service or component by then.
 *
 * (This is a decision to keep the MessagingService from having to know anything
 * about the receivers.)
 *
 * TODO: Now that we're in a multi-module world (_sort of_), this process will
 * need to be adapted or discarded, since child modules won't be available until
 * their host route is activated (and eagerly loading them would defeat some of
 * the benefits of separating the module in the first place). [TDHS]
 */
export const LAUNCH_DEPENDENCY_PROVIDER : FactoryProvider = {
  provide: LAUNCH_DEPENDENCIES,
  useFactory: init,
  deps : [
    AggregationService, // TODO: isn't this forcing load of the aggregator pkg?
    AlertService,
    CollaborationService,
    DebugService,
    MessagingService,
    NavigationHistoryService,
    SearchService,
    SubjectService,
    UseModalsForBrowserAlerts,
    WatchlistService
  ]
};



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/launch-dependencies.ts